var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tag',{attrs:{"color":_vm.getStatusColor(_vm.status)}},[_vm._v("\n  "+_vm._s(_vm.getStatusName(_vm.status))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }